import { render, staticRenderFns } from "./PrintCorpFooter.vue?vue&type=template&id=a664ef9a&scoped=true&"
import script from "./PrintCorpFooter.vue?vue&type=script&lang=js&"
export * from "./PrintCorpFooter.vue?vue&type=script&lang=js&"
import style0 from "./PrintCorpFooter.vue?vue&type=style&index=0&id=a664ef9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a664ef9a",
  null
  
)

export default component.exports